import { useState, useEffect } from 'react'
import { useSnackbar } from "../components/snackbar/snackbar"

export const standardInvalidate = (init, data, resp) => Array.isArray(init) && data?.length === resp?.length
export const neverCache = (init, data, resp) => false

export const invalidateNotification = (init, data, resp) => {
    const unNotifiedNotification = !!resp?.find(x => x?.notified === false)
    const isAllNotified = unNotifiedNotification === undefined
    return data?.length > 0 && isAllNotified
}

export const invalidateProcessing = (_, data, resp) => {    
    const haveTransientData = !!data?.find(x => ["processing", "queued"].includes(x?.status))
    const haveTransientResp = !!resp?.find(x => ["processing", "queued"].includes(x?.status))
    return !haveTransientData && !haveTransientResp && data?.length > 0
}


const useFetch = (request, init = undefined, isCached = neverCache) => {
    const [data, setData] = useState(init)
    const [completed, setCompleted] = useState(false)
    const [loading, setLoading] = useState(true)
    const { enqueueSnackbar } = useSnackbar()

    const refresh = async () => {
        try{
            const resp = await request()
            if (!isCached(init, data, resp)) {
                // we want to avoid superfluous re-renders
                setData(resp)
            }
        } catch(err) {
            if (enqueueSnackbar !== undefined) {
                enqueueSnackbar("Request Failed: If this issue persists, please contact support.", {
                    variant: "error"                
                })
            }

            console.error(err)
        }        
        setCompleted(true)
        setLoading(false)
    }

    useEffect(() => {
        refresh()
    }, [])

    return {
        refresh, data, loading, completed
    }
}

export default useFetch